module.exports = __webpack_public_path__ + "img/item_assistente_virtual.4e7b1d6f.svg";